import axios from "axios";
const host = process.env.REACT_APP_API_URL;
const token = localStorage.getItem("token");

export async function fetchMentorMenteesCount() {
  const res = await axios.get(`${host}api/missionControl/mentorMenteesCount`, {
    headers : {
      token,
    },
  });
  return res;
}

export async function fetchTasksApi(domainid) {
  const res = await axios.get(`${host}api/tasks/read/${domainid}`, {
    headers: {
      token,
    },
  });
  // const res = await axios({
  //   url: host + "/api/tasks/read/" + domainid,
  //   method: "GET",
  //   headers: { token: token },
  // });
  return res;
}

export async function updateMentorApi(values) {
  const res = await axios.post(
    `${host}api/missionControl/changeMentorMentee`,
    values, {
      headers: {
        token,
      },
    }
  );
  // const res = await axios({
  //   url: host + "api/missionControl/changeMentorMentee",
  //   method: "POST",
  //   headers: { token: token },
  //   data: values,
  // });
  return res;
}

export async function allowTaskSubmissionApi(values) {
  const res = await axios.post(
    `${host}api/missionControl/taskSubmission/allow`,
    values, {
      headers: {
        token,
      },
    }
  );
  // const res = await axios({
  //   url: host + "api/missionControl/taskSubmission/allow",
  //   method: "POST",
  //   headers: { token: token },
  //   data: values,
  // });
  return res;
}

export async function disallowTaskSubmissionApi(values) {
  const res = await axios.post(
    `${host}api/missionControl/taskSubmission/notAllow`,
    values, {
      headers: {
        token,
      },
    }
  );
  // const res = await axios({
  //   url: host + "api/missionControl/taskSubmission/notAllow",
  //   method: "POST",
  //   headers: { token: token },
  //   data: values,
  // });
  return res;
}

export async function updateShowResultApi(values) {
  const res = await axios.post(`${host}api/missionControl/taskResult`, values, {
    headers: {
      token,
    },
  });
  // const res = await axios({
  //   url: host + "api/missionControl/taskResult",
  //   method: "POST",
  //   headers: { token: token },
  //   data: values,
  // });
  return res;
}

export async function eliminateMenteeApi(values) {
  const res = await axios.post(
    `${host}api/missionControl/settings/updateRejRound`,
    values, {
      headers: {
        token,
      },
    }
  );
  // const res = await axios({
  //   url: host + "api/missionControl/settings/updateRejRound",
  //   method: "POST",
  //   headers: { token: token },
  //   data: values,
  // });
  return res;
}

export async function inductMenteeApi(values) {
  const res = await axios.post(
    `${host}api/missionControl/inductMentees`,
    values, {
      headers: {
        token,
      },
    }
  );
  // const res = await axios({
  //   url: host + "api/missionControl/inductMentees",
  //   method: "POST",
  //   headers: { token: token },
  //   data: values,
  // });
  return res;
}

export async function handleMembersApi(values) {
  const res = await axios.post(`${host}api/general/addmembers`, values, {
    headers: {
      token,
      "content-type": "multipart/form-data",
    },
  });
  // const res = await axios({
  //   url: host + "api/general/addmembers",
  //   method: "POST",
  //   headers: { token: token, "content-type": "multipart/form-data" },
  //   data: values,
  // });
  return res;
}